import { useAuthActions } from "@convex-dev/auth/react";
import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
import { useConvexAuth } from "convex/react";
import { api } from "../../convex/_generated/api";

export function useAuth() {
  const { signIn, signOut } = useAuthActions();
  const convexAuth = useConvexAuth();
  const { data: user, error } = useQuery(
    convexQuery(api.users.getCurrentUser, convexAuth.isAuthenticated ? {} : "skip"),
  );

  if (error) {
    throw error;
  }

  const isLoading = convexAuth.isLoading || (convexAuth.isAuthenticated && user === undefined);
  const isAuthenticated = convexAuth.isAuthenticated && user !== null && user !== undefined;

  return {
    user,
    isLoading,
    isAuthenticated,
    signIn,
    signOut,
  };
}
